// extracted by mini-css-extract-plugin
export var fadein = "scrolling-tooltips-module--fadein--377af";
export var tooltip = "scrolling-tooltips-module--tooltip--db008";